import {
  initialState,
  Actions,
  State,
  ACCEPT_INVITATION,
  ACCEPT_INVITATION_SUCCESS,
  ACCEPT_INVITATION_ERROR,
} from "../../types/invitation/accept";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case ACCEPT_INVITATION:
      return {
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case ACCEPT_INVITATION_SUCCESS:
      return {
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case ACCEPT_INVITATION_ERROR:
      return {
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
